import type { UserResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';
import { toLinkedInUrlBody } from '@/shared/linkedin/linkedin-url';

import type { UserDraft } from '../../_shared/domain/user-draft.model';
import type { EditUserGateway } from './edit-user.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the Edit-user endpoints and body mappings. Loading reuses the users list then
 * finds by id, as the original page did (no dedicated GET /users/:id); the
 * licence name is read off the loaded user (`licence_name`), so, unlike the
 * original, no separate GET /licences is needed.
 */
export const httpEditUserGateway: EditUserGateway = {
  loadUser: async (id: string) => {
    const users = await api.get<UserResponse[]>('/users');
    return users.find((u) => u.id === id) ?? null;
  },
  updateUser: async (id: string, draft: UserDraft) => {
    await api.patch(`/users/${id}`, {
      first_name: draft.firstName.trim(),
      last_name: draft.lastName.trim(),
      email: draft.email.trim(),
      // Always sent: an emptied field is how the URL is cleared (`null`).
      linkedin_url: toLinkedInUrlBody(draft.linkedinUrl),
    });
  },
};
